module.exports = __webpack_public_path__ + "static/media/alert-triangle.43ccf89a.svg";